import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/taskList/importer/taskListImporterActions'

export default importerReducers(actions)
